import { render, staticRenderFns } from "./TrackItemAndScore.vue?vue&type=template&id=6c637b5e&scoped=true&"
import script from "./TrackItemAndScore.vue?vue&type=script&lang=js&"
export * from "./TrackItemAndScore.vue?vue&type=script&lang=js&"
import style0 from "./TrackItemAndScore.vue?vue&type=style&index=0&id=6c637b5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c637b5e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
